// Curated Unsplash interior / architecture photo pools.
// Each set is used for a specific section slot — a random entry is picked on each page load.

const Q = "?auto=format&fit=crop&w=2560&q=95";
const u = (id) => `https://images.unsplash.com/photo-${id}${Q}`;

// Dark, moody living-room / loft interiors — for hero sections with dark overlays
export const HERO_PHOTOS = [
  u("1586023492125-27b2c045efd7"), // dim grey living room
  u("1618221195710-dd6b41faaea6"), // warm-lit lounge
  u("1556909114-f6e7ad7d3136"),    // sleek modern kitchen
  u("1560448204-e02f11c3d0e2"),    // minimalist apartment
  u("1631049307264-da0ec9d70304"), // architectural bedroom
  u("1617103996702-96ff29b1c467"), // moody modern interior
  u("1565182999561-18d7dc61c393"), // earthy warm lounge
];

// Bright / inviting interiors — for "Who it's for" and lifestyle sections
export const USECASE_PHOTOS = [
  u("1600585154340-be6161a56a0c"), // bright airy living room
  u("1555041469-a586c61ea9bc"),    // cosy sofa & natural light
  u("1493809842364-78817add7ffb"), // sunlit bedroom
  u("1524758631624-e2822e304c36"), // open-plan modern space
  u("1616594039964-ae9021a400a0"), // Scandinavian dining area
  u("1567767292278-a4f21aa2d36e"), // Nordic lounge with plant
  u("1493246318656-5bfd4cfb29b8"), // warm bright living space
];

// Premium bedroom / suite / calm interiors — for final CTA sections
export const CTA_PHOTOS = [
  u("1600566753190-17f0baa2a6c3"), // Japandi bedroom
  u("1615874959474-d609969a20ed"), // hotel-style suite
  u("1502005229762-cf1b2da7c5d6"), // window with natural light
  u("1571508601891-ca5e7a713859"), // luxe neutral bedroom
  u("1484101403633-562f891dc89a"), // modern white interior
  u("1540518614846-7eded433c457"), // calm minimalist bedroom
  u("1595526051245-4506e0005bd0"), // serene room detail
];

/** Pick a stable-random photo from a pool (stable for the lifetime of the component). */
export function pick(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}
